"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.reflect.construct.js");

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.split.js");

require("core-js/modules/es6.object.set-prototype-of.js");

require("core-js/modules/es6.object.get-prototype-of.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _materialUi = require("material-ui");

var _ImageCropper = _interopRequireDefault(require("./ImageCropper"));

var _ImageUploader = _interopRequireDefault(require("./ImageUploader"));

var _DashModal = _interopRequireDefault(require("../DashModal"));

var _utils = require("../../../../lib/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var blankImg = require('../../../../images/no-photo@2x.png');

require('../../../../sass/components/shared/elements/imageUpload/MuiUploader.css');

var MuiUploader = /*#__PURE__*/function (_React$Component) {
  _inherits(MuiUploader, _React$Component);

  var _super = _createSuper(MuiUploader);

  function MuiUploader(props) {
    var _this;

    _classCallCheck(this, MuiUploader);

    _this = _super.call(this, props);
    _this.state = {
      error: {},
      progress: null,
      cropModalOpen: false,
      imageSrc: '',
      imageName: ''
    };
    _this.handleProgress = _this.handleProgress.bind(_assertThisInitialized(_this));
    _this.handleUploadFinish = _this.handleUploadFinish.bind(_assertThisInitialized(_this));
    _this.onRemoveClick = _this.onRemoveClick.bind(_assertThisInitialized(_this));
    _this.toggleCropModal = _this.toggleCropModal.bind(_assertThisInitialized(_this));
    _this.renderBrowseButton = _this.renderBrowseButton.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MuiUploader, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.image !== nextProps.image || !this.state.imageSrc && nextProps.image) {
        var imageName = nextProps.image.split('_')[1] || 'cropped-photo.jpg';
        this.setState({
          imageSrc: nextProps.image,
          imageName: imageName
        });
      }
    }
  }, {
    key: "handleProgress",
    value: function handleProgress(progress) {
      this.setState({
        progress: progress
      });
    }
  }, {
    key: "handleUploadFinish",
    value: function handleUploadFinish(url) {
      this.props.handleUpload({
        target: {
          value: url,
          validity: {
            valid: true
          }
        }
      });
      this.setState({
        progress: null,
        cropModalOpen: false
      });
    }
  }, {
    key: "onRemoveClick",
    value: function onRemoveClick() {
      this.imageUploader.clearFileInput();
      this.props.handleUpload({
        target: {
          value: '',
          validity: {
            valid: true
          }
        }
      });
      this.handleAnalytics('remove');
    }
  }, {
    key: "toggleCropModal",
    value: function toggleCropModal(state) {
      var cropModalOpen = typeof state !== 'undefined' ? state : !this.state.cropModalOpen; // on open

      if (cropModalOpen) {
        this.handleAnalytics('crop');
      }

      this.setState({
        cropModalOpen: cropModalOpen
      });
    }
  }, {
    key: "handleAnalytics",
    value: function handleAnalytics(type) {
      var analyticsObject = this.props.analyticsObject;
      analyticsObject && analyticsObject[type] && (0, _utils.googleAnalytics)(analyticsObject[type])();
    }
  }, {
    key: "renderBrowseButton",
    value: function renderBrowseButton() {
      var _this2 = this;

      return /*#__PURE__*/_react.default.createElement(_materialUi.RaisedButton, {
        secondary: true,
        label: "Browse",
        labelStyle: {
          textTransform: 'none'
        },
        onClick: function onClick(e) {
          _this2.imageUploader.clickFileInput();

          _this2.handleAnalytics('browse');
        },
        style: {
          boxShadow: 'none',
          marginTop: 'auto',
          minWidth: '12rem'
        },
        className: "browse"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          progress = _this$state.progress,
          imageSrc = _this$state.imageSrc,
          imageName = _this$state.imageName;
      var _this$props = this.props,
          image = _this$props.image,
          label = _this$props.label,
          gaKey = _this$props.gaKey,
          analyticsObject = _this$props.analyticsObject;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "photo-upload"
      }, /*#__PURE__*/_react.default.createElement(_DashModal.default, {
        isModal: false,
        title: "Crop Image",
        className: "image-crop-modal",
        isOpen: this.state.cropModalOpen,
        handleClose: function handleClose(e) {
          _this3.toggleCropModal(false);

          _this3.handleAnalytics('closeCropModal');
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "image-crop-modal"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "crop-container"
      }, /*#__PURE__*/_react.default.createElement(_ImageCropper.default, {
        handleUpload: this.handleUploadFinish,
        imageName: imageName,
        imageSrc: imageSrc,
        height: 400,
        ref: function ref(el) {
          return _this3.imageCropper = el;
        }
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "crop-modal-buttons"
      }, /*#__PURE__*/_react.default.createElement(_materialUi.FlatButton, {
        label: "Cancel",
        className: "crop-cancel-button",
        onClick: function onClick(e) {
          _this3.toggleCropModal(false);

          _this3.handleAnalytics('cancelCropModal');
        }
      }), /*#__PURE__*/_react.default.createElement(_materialUi.RaisedButton, {
        primary: true,
        label: "Save",
        className: "crop-save-button",
        onClick: function onClick(e) {
          _this3.imageCropper.crop();

          _this3.handleAnalytics('saveCropModal');
        }
      })))), /*#__PURE__*/_react.default.createElement(_materialUi.Paper, {
        className: "photo-upload-viewer",
        zDepth: 1,
        rounded: false,
        style: image && !progress ? {
          backgroundImage: "url(".concat(image, ")")
        } : {}
      }, !image && !progress && /*#__PURE__*/_react.default.createElement("img", {
        src: blankImg,
        className: "photo-upload-viewer-blank",
        alt: "No Image Uploaded"
      }), progress > 0 && /*#__PURE__*/_react.default.createElement(_materialUi.CircularProgress, {
        size: 95,
        thickness: 7,
        value: progress,
        mode: "determinate"
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "photo-upload-ui"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "upload-instructions-container"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "upload-title"
      }, /*#__PURE__*/_react.default.createElement("strong", null, label)), /*#__PURE__*/_react.default.createElement("p", {
        className: "upload-subtitle"
      }, "Upload .PNG or .JPG image")), /*#__PURE__*/_react.default.createElement("div", {
        className: "image-buttons-container"
      }, image && /*#__PURE__*/_react.default.createElement(_materialUi.RaisedButton, {
        secondary: true,
        label: "Crop & Rotate",
        labelStyle: {
          textTransform: 'none'
        },
        onClick: function onClick() {
          return _this3.toggleCropModal(true);
        },
        style: {
          boxShadow: 'none',
          marginTop: 'auto',
          minWidth: '24rem'
        },
        className: "crop"
      }), /*#__PURE__*/_react.default.createElement(_ImageUploader.default, {
        acceptedTypes: 'image/png, image/jpg, image/jpeg, image/gif',
        handleUpload: this.handleUploadFinish,
        handleProgress: this.handleProgress,
        ref: function ref(el) {
          return _this3.imageUploader = el;
        },
        render: this.renderBrowseButton
      }), image && /*#__PURE__*/_react.default.createElement(_materialUi.RaisedButton, {
        secondary: true,
        label: "Remove",
        labelStyle: {
          textTransform: 'none'
        },
        onClick: this.onRemoveClick,
        style: {
          boxShadow: 'none',
          marginTop: 'auto',
          minWidth: '12rem'
        },
        className: "remove"
      }))));
    }
  }]);

  return MuiUploader;
}(_react.default.Component);

exports.default = MuiUploader;
MuiUploader.propTypes = {
  image: _propTypes.default.string,
  label: _propTypes.default.string.isRequired,
  gaKey: _propTypes.default.string.isRequired,
  handleUpload: _propTypes.default.func.isRequired,
  analyticsObject: _propTypes.default.shape({
    browse: _propTypes.default.string,
    crop: _propTypes.default.string,
    remove: _propTypes.default.string,
    closeCropModal: _propTypes.default.string,
    cancelCropModal: _propTypes.default.string,
    saveCropModal: _propTypes.default.string
  })
};